import AssessmentIcon from '@mui/icons-material/Assessment';

import ReviewList from './ReviewList';
import ReviewCreate from './ReviewCreate';
import ReviewEdit from './ReviewEdit';
import ReviewShow from './ReviewShow';


const reviews = {
	list: ReviewList,
	create: ReviewCreate,
	edit: ReviewEdit,
	show: ReviewShow,
	icon: AssessmentIcon
};

export default reviews;
